export const findSuffixes = (position) => {
    if (position === 11 || position === 12 || position === 13) return `${position}th`
    else if (position === 1 || position % 10 === 1) return `${position}st`
    else if (position === 2 || position % 10 === 2) return `${position}nd`
    else if (position === 3 || position % 10 === 3) return `${position}rd`
    else if (position <= 50) return `${position}th`
    else return "last"
}